import { render, staticRenderFns } from "./MainColumnsTable.vue?vue&type=template&id=263302de&"
import script from "./MainColumnsTable.vue?vue&type=script&lang=js&"
export * from "./MainColumnsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports